import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

const SmsExample = function SmsExample({ value = '' }) {
  const intl = useIntl();
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '24px',
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          padding: '16px',
          position: 'relative',
          borderRadius: '25px 25px 0px 25px',
          display: 'flex',
          flexDirection: 'column',
          gap: '18px',
          backgroundColor: '#1d5b9d',
          color: '#fff',
        }}
      >
        <Typography variant="h6">{intl.messages.PREVIEW}</Typography>
        <Typography variant="body1" sx={{ overflow: 'auto' }}>
          {value?.replaceAll('&nbsp;', ' ')}
        </Typography>
      </div>
    </div>
  );
};

SmsExample.propTypes = {
  value: PropTypes.string,
};

export default SmsExample;
